/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Payment_Percentage_RangeInputs */

const en_clients_validation_payment_percentage_range = /** @type {(inputs: Clients_Validation_Payment_Percentage_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a percentage between 0 and 100.`)
};

const pt_br2_clients_validation_payment_percentage_range = /** @type {(inputs: Clients_Validation_Payment_Percentage_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe um percentual entre 0 e 100.`)
};

/**
* | output |
* | --- |
* | "Enter a percentage between 0 and 100." |
*
* @param {Clients_Validation_Payment_Percentage_RangeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_payment_percentage_range = /** @type {((inputs?: Clients_Validation_Payment_Percentage_RangeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Payment_Percentage_RangeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_payment_percentage_range(inputs)
	return pt_br2_clients_validation_payment_percentage_range(inputs)
});